<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.25 1C13.6642 1 14 1.33579 14 1.75V14.25C14 14.6642 13.6642 15 13.25 15C12.8358 15 12.5 14.6642 12.5 14.25V1.75C12.5 1.33579 12.8358 1 13.25 1ZM8 8C8.41421 8 8.75 8.33579 8.75 8.75V14.25C8.75 14.6642 8.41421 15 8 15C7.58579 15 7.25 14.6642 7.25 14.25V8.75C7.25 8.33579 7.58579 8 8 8ZM3.5 6.75C3.5 6.33579 3.16421 6 2.75 6C2.33579 6 2 6.33579 2 6.75V14.25C2 14.6642 2.33579 15 2.75 15C3.16421 15 3.5 14.6642 3.5 14.25V6.75Z"
    fill="currentColor"
  />
</svg>
